import { render } from "./XIconSolidChartPieSlice.vue?vue&type=template&id=8cbe4908"
import script from "./XIconSolidChartPieSlice.vue?vue&type=script&lang=js"
export * from "./XIconSolidChartPieSlice.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidChartPieSlice.vue"]])

export default __exports__